import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './LS.css';
import ReactLoading from 'react-loading';
import ccp_logo from '../../../Assests/ccp_logo.png';
import eastwest_logo from '../../../Assests/eastwest_logo.png';
import { firebaseServices } from '../../../Firebase/FirebaseServices'


// import * as Icon from "react-icons/fi";
import checkIcon from '../../../Assests/checkIcon.svg'
import Checkbox from "react-custom-checkbox";

import NameAndEmail from '../NameAndEmail/NameAndEmail';
import Frame1 from '../../Episode1/Frame1/Frame1';
import Frame2 from '../../Episode1/Frame2/Frame2';
import Frame3 from '../../Episode1/Frame3/Frame3';
import Frame4 from '../../Episode1/Frame4/Frame4';
import Frame5 from '../../Episode1/Frame5/Frame5';
import Frame6 from '../../Episode1/Frame6/Frame6';
import Frame7 from '../../Episode1/Frame7/Frame7';
import Frame8 from '../../Episode1/Frame8/Frame8';
import Frame9 from '../../Episode1/Frame9/Frame9';
import Frame10 from '../../Episode1/Frame10/Frame10';
import Frame11 from '../../Episode1/Frame11/Frame11';
import Frame12 from '../../Episode1/Frame12/Frame12';
import Frame13 from '../../Episode1/Frame13/Frame13';
import Frame14 from '../../Episode1/Frame14/Frame14';
import Frame15 from '../../Episode1/Frame15/Frame15';
import Frame16 from '../../Episode1/Frame16/Frame16';
import Frame17 from '../../Episode1/Frame17/Frame17';
import Frame18 from '../../Episode1/Frame18/Frame18';
import Frame19 from '../../Episode1/Frame19/Frame19';
import Frame20 from '../../Episode1/Frame20/Frame20';
import Frame21 from '../../Episode1/Frame21/Frame21';
import Frame22 from '../../Episode1/Frame22/Frame22';
import Frame23 from '../../Episode1/Frame23/Frame23';

/* Episode 2 Frames */
import Frame24 from '../../Episode2/Frame24/Frame24';
import Frame25 from '../../Episode2/Frame25/Frame25';
import Frame26 from '../../Episode2/Frame26/Frame26';
import Frame27 from '../../Episode2/Frame27/Frame27';
import Frame28 from '../../Episode2/Frame28/Frame28';
import Frame29 from '../../Episode2/Frame29/Frame29';
import Frame30 from '../../Episode2/Frame30/Frame30';
import Frame31 from '../../Episode2/Frame31/Frame31';
import Frame32 from '../../Episode2/Frame32/Frame32';
import Frame33 from '../../Episode2/Frame33/Frame33';
import Frame34 from '../../Episode2/Frame34/Frame34';
import Frame35 from '../../Episode2/Frame35/Frame35';
import Frame36 from '../../Episode2/Frame36/Frame36';
import Frame37 from '../../Episode2/Frame37/Frame37';
import Frame38 from '../../Episode2/Frame38/Frame38';
import Frame39 from '../../Episode2/Frame39/Frame39';
import Frame40 from '../../Episode2/Frame40/Frame40';
import Frame41 from '../../Episode2/Frame41/Frame41';
import Frame42 from '../../Episode2/Frame42/Frame42';
import Frame43 from '../../Episode2/Frame43/Frame43';
import Frame44 from '../../Episode2/Frame44/Frame44';
import Frame45 from '../../Episode2/Frame45/Frame45';
import Frame46 from '../../Episode2/Frame46/Frame46';
import Frame47 from '../../Episode2/Frame47/Frame47';
import Frame48 from '../../Episode2/Frame48/Frame48';
import Frame49 from '../../Episode2/Frame49/Frame49';
import Frame50 from '../../Episode2/Frame50/Frame50';

/* Episode 3 Frames */
import Frame51 from '../../Episode3/Frame51/Frame51';
import Frame52 from '../../Episode3/Frame52/Frame52';
import Frame53 from '../../Episode3/Frame53/Frame53';
import Frame54 from '../../Episode3/Frame54/Frame54';
import Frame55 from '../../Episode3/Frame55/Frame55';
import Frame56 from '../../Episode3/Frame56/Frame56';
import Frame57 from '../../Episode3/Frame57/Frame57';
import Frame58 from '../../Episode3/Frame58/Frame58';
import Frame59 from '../../Episode3/Frame59/Frame59';
import Frame60 from '../../Episode3/Frame60/Frame60';
import Frame61 from '../../Episode3/Frame61/Frame61';
import Frame62 from '../../Episode3/Frame62/Frame62';
import Frame63 from '../../Episode3/Frame63/Frame63';
import Frame64 from '../../Episode3/Frame64/Frame64';
import Frame65 from '../../Episode3/Frame65/Frame65';
import Frame66 from '../../Episode3/Frame66/Frame66';
import Frame67 from '../../Episode3/Frame67/Frame67';
import Frame68 from '../../Episode3/Frame68/Frame68';
import Frame69 from '../../Episode3/Frame69/Frame69';


function MainPage() {
    var nextUpdateTime = 80; /* 2000ms */
    let [preRenderingInterval, setPreRenderingInterval] = useState(0);
    let [isLoading, setIsLoading] = useState(true)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {
        firebaseServices.database().ref('/clickedUsers/' + new Date().toString()).set
        ({
           referrer: `${document.referrer}`,
        })
       
        // setTimeout(function () { setIsLoading(false) }, 2000);
        window.onload = ()=>{
             setTimeout(function () { setIsLoading(false) }, (2000));
        }
        
        
        for(let i=1 ; i<=23; i++){
            setTimeout(function () { setPreRenderingInterval(i) }, (i*nextUpdateTime));
        }
    }, [])
    

    if (isLoading === true) {
        return (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', overflow: 'hidden' }}>
            <div style={{ position: "absolute", top: 'center', left: 'center', }}>
                <ReactLoading type={'bars'} color={'#f89a2d'} height={100} width={100} />

            </div>

            {/* precomponents loading for smooth experience */}
            <div style={{ height: '10vh', width: '10vw', opacity: 0, }}>
                <NameAndEmail />
                
                {(preRenderingInterval === 1) ? 
                <> <Frame1 /> <Frame24 /> <Frame51 /> </>
                : ''}
                
                {(preRenderingInterval === 2) ? 
                <> <Frame2 /> <Frame25 /> <Frame52 /> </>
                : ''}
                 
                {(preRenderingInterval === 3) ? 
                <> <Frame3 /> <Frame26 /> <Frame53 /> </>
                : ''}
       
                {(preRenderingInterval === 4) ? 
                <> <Frame4 /> <Frame27 /> <Frame54 /> </>
                : ''} 
                
                {(preRenderingInterval === 5) ? 
                <> <Frame5 /> <Frame28 /> <Frame55 /> </>
                : ''}
                 
                 {(preRenderingInterval === 6) ? 
                <> <Frame6 /> <Frame29 /> <Frame56 /> </>
                : ''}
                 
                 {(preRenderingInterval === 7) ? 
                <> <Frame7 /> <Frame30 /> <Frame57 /> </>
                : ''}
                 
                 {(preRenderingInterval === 8) ? 
                <> <Frame8 /> <Frame31 /> <Frame58 /> </>
                : ''}
                 
                 {(preRenderingInterval === 9) ? 
                <> <Frame9 /> <Frame32 /> <Frame59 /> </>
                : ''}
                 
                 {(preRenderingInterval === 10) ? 
                <> <Frame10 /> <Frame33 /> <Frame60 /> </>
                : ''}
                 
                 {(preRenderingInterval === 11) ? 
                <> <Frame11 /> <Frame34 /> <Frame61 /> </>
                : ''}
                 
                 {(preRenderingInterval === 12) ? 
                <> <Frame12 /> <Frame35 /> <Frame62 /> </>
                : ''}
                 
                 {(preRenderingInterval === 13) ? 
                <> <Frame13 /> <Frame36 /> <Frame63 /> </>
                : ''}
                 
                 {(preRenderingInterval === 14) ? 
                <> <Frame14 /> <Frame37 /> <Frame64 /> </>
                : ''}
                 
                 {(preRenderingInterval === 15) ? 
                <> <Frame15 /> <Frame38 /> <Frame65 /> </>
                : ''}
                 
                 {(preRenderingInterval === 16) ? 
                <> <Frame16 /> <Frame39 /> <Frame66 /> </>
                : ''}
                 
                 {(preRenderingInterval === 17) ? 
                <> <Frame17 /> <Frame40 /> <Frame67 /> </>
                : ''}
                 
                 {(preRenderingInterval === 18) ? 
                <> <Frame18 /> <Frame41 /> <Frame68 /> </>
                : ''}
                 
                 {(preRenderingInterval === 19) ? 
                <> <Frame19 /> <Frame42 /> <Frame69 /> </>
                : ''}
                 
                 {(preRenderingInterval === 20) ? 
                <> <Frame20 /> <Frame43 />  <Frame46 /> </>
                : ''}
                 
                 {(preRenderingInterval === 21) ? 
                <> <Frame21 /> <Frame44 /> <Frame47 />  </>
                : ''}
                 
                 {(preRenderingInterval === 22) ? 
                <> <Frame22 /> <Frame45 /> <Frame48 />  </>
                : ''}
                 
                 {(preRenderingInterval === 23) ? 
                <> <Frame23 />  <Frame49 />  <Frame50 />  </>
                : ''}


               
            </div>
        </div>)
    } else {
        return (
            <div className='LS_mainDiv'>
                    <img className='LS_ccp_logo' src={ccp_logo} alt='ccp_logo' />
                    <img className='LS_eastwest_logo' src={eastwest_logo} alt='eastwest_logo' />
                <div className="LS_box">
                    <div className='LS_boxTitle'>
                        {language === 'english' ?
                            <p className='LS_boxTitle_textEnglish'>Saira needs help !</p>

                            :
                            <p className='LS_boxTitle_textUrdu'>!سائرا کو مدد چاہیے</p>

                        }
                    </div>

                    <div className='LS_languages'>
                        <p className='LS_instructionEnglish'>Please select your language</p>
                        <div className='LS_languagesBox'>
                            <Checkbox
                                // size={window.innerWidth*0.015}
                                size={getResponsiveCheckbox(window.innerWidth)}
                                icon={<img src={checkIcon} alt="React Logo" height={getResponsiveIconHeight(window.innerWidth)} />}
                                checked={(language === 'english' ? true : false)}
                                onChange={(value) => { dispatch(setLanguageEnglish()) }}
                                borderColor="#f89a2d"
                                style={{ cursor: "pointer", marginLeft: `${getResponsivemarginLeft(window.innerWidth)}vw` }}
                                labelStyle={{ marginLeft: `${getResponsivemarginLeft(window.innerWidth)}vw`, userSelect: "none", color: 'rgb(255,255,255)', fontSize: getResponsiveFontSize(window.innerWidth) }}
                                label="English"
                            />
                        </div>

                        <p className='LS_instructionUrdu'>اپنی زبان کا اِنتخاب کریں</p>
                        <div className='LS_languagesBox'>
                            <Checkbox
                                // size={window.innerWidth*0.015}
                                size={getResponsiveCheckbox(window.innerWidth)}
                                icon={<img src={checkIcon} alt="React Logo" height={getResponsiveIconHeight(window.innerWidth)} />}
                                checked={(language === 'urdu' ? true : false)}
                                onChange={(value) => { dispatch(setLanguageUrdu()) }}
                                borderColor="#f89a2d"
                                style={{ cursor: "pointer", marginLeft: `${getResponsivemarginLeft(window.innerWidth)}vw` }}
                                labelStyle={{ marginLeft: `${getResponsivemarginLeft(window.innerWidth)}vw`, userSelect: "none", color: 'rgb(255,255,255)', fontSize: getResponsiveFontSize(window.innerWidth) }}
                                label="اردو"
                            />
                        </div>
                    </div>

                    <div className='LS_buttonsDiv'>
                        <button onClick={() => { dispatch(pageUp()) }} className='LS_button'>
                            {language === 'english' ? 'Start' : 'آگے  جائیں'}
                        </button>
                    </div>
                </div>

            </div>
        )
    }

}

export default MainPage

function getResponsiveCheckbox(vw) {
    if (vw >= 1201) {
        return vw * 0.018
    } else if (vw >= 1025 && vw <= 1200) {
        return vw * 0.02
    } else if (vw >= 769 && vw <= 1024) {
        return vw * 0.026
    } else if (vw >= 481 && vw <= 768) {
        return vw * 0.045
    } else if (vw <= 480) {
        return vw * 0.07
    }
}

function getResponsiveIconHeight(vw) {
    if (vw >= 1201) {
        return vw * 0.01
    } else if (vw >= 1025 && vw <= 1200) {
        return vw * 0.013
    } else if (vw >= 769 && vw <= 1024) {
        return vw * 0.015
    } else if (vw >= 481 && vw <= 768) {
        return vw * 0.026
    } else if (vw <= 480) {
        return vw * 0.06
    }
}

function getResponsivemarginLeft(vw) {
    if (vw >= 1201) {
        return vw * 0.0012
    } else if (vw >= 1025 && vw <= 1200) {
        return vw * 0.0016
    } else if (vw >= 769 && vw <= 1024) {
        return vw * 0.0017
    } else if (vw >= 481 && vw <= 768) {
        return vw * 0.003
    } else if (vw <= 480) {
        return vw * 0.01
    }
}

function getResponsiveFontSize(vw) {
    if (vw >= 1201) {
        return vw * 0.017
    } else if (vw >= 1025 && vw <= 1200) {
        return vw * 0.02
    } else if (vw >= 769 && vw <= 1024) {
        return vw * 0.027
    } else if (vw >= 481 && vw <= 768) {
        return vw * 0.045
    } else if (vw <= 480) {
        return vw * 0.06
    }
}
